export default{
    namespaced: true,
    
    state() {
        return {
            ticketsList: null
        }
    },
    mutations: {
        setTicketsList(state, ticketListResponse){
            state.ticketsList = ticketListResponse;
        },
        updateTicketsListAfterAddingComment(state, updatedTicket){
            let index = state.ticketsList.findIndex(ticket => ticket.uid === updatedTicket.uid);
            state.ticketsList[index] = updatedTicket;
            console.log("done")
        }
    },
    actions: {

    },
    getters: {

    },
    modules:{

    }
    
}